import {priority} from '@priority-software/priority-proto-api/lib';

export const getSubFormFallbackType = (subFormsList: priority.netitems.form.ISubform[] = []) => {
    return subFormsList[0]?.IsText ? 'htmlForm' : 'dataForm';
};

export const getSubFormFallbackId = (subFormsList: priority.netitems.form.ISubform[] = []) => {
    return subFormsList[0]?.Ename;
};
